import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Radio, Select, Typography } from 'antd';
import { useState } from 'react';
import colors from '../../../../constants/ColourConstants';

export default function UpdateTransactionModal({
  onOk,
  open,
  setOpen,
  n,
  count,
}) {
  const { Text } = Typography;
  const [transactionUpdateType, setTransactionUpdateType] =
    useState('selected');
  const [newStatus, setNewStatus] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  return (
    <>
      <Modal
        title="Update Transaction Statuses"
        open={open}
        onCancel={() => setOpen(false)}
        onClose={() => setOpen(false)}
        okButtonProps={{
          disabled: !newStatus,
        }}
        onOk={() => {
          setShowConfirmModal(true);
          setOpen(false);
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Text>Choose which transactions to update.</Text>
          <Text style={{ fontSize: 12 }} italic>
            Note: Only transactions that are NOT added to an invoice and voided
            can be updated.
          </Text>
        </div>
        <Radio.Group
          onChange={(e) => setTransactionUpdateType(e.target.value)}
          defaultValue={'selected'}
          value={transactionUpdateType}
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: '8px 0',
            gap: 4,
          }}
        >
          <Radio value={'selected'}>
            Selected transactions only -{' '}
            <Text strong>{n || 0} transactions selected</Text>
          </Radio>
          <Radio value={'query'}>
            All eligible transactions -{' '}
            <Text strong>{count || 0} transactions </Text>
          </Radio>
        </Radio.Group>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            margin: '12px 0',
          }}
        >
          <Text>Change status to</Text>
          <Select
            onSelect={setNewStatus}
            value={newStatus}
            placeholder="Select status"
            style={{ width: '60%' }}
          >
            <Radio value={'Ready for Invoice'}>Ready for Invoice</Radio>
            <Radio value={'Under Further Review'}>Under Further Review</Radio>
            <Radio value={'Voided'}>Voided</Radio>
          </Select>
        </div>
      </Modal>

      <Modal
        width={'25%'}
        open={showConfirmModal}
        title={
          <>
            <ExclamationCircleOutlined style={{ color: colors.colorWarning }} />
            <Text style={{ marginLeft: 8 }}>
              Confirm Transaction Status Update
            </Text>
          </>
        }
        onCancel={() => {
          setShowConfirmModal(false);
          setOpen(true);
        }}
        onOk={() => {
          onOk(transactionUpdateType, null, newStatus);
          setShowConfirmModal(false);
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <Text>
            You&apos;re about to update{' '}
            <Text strong>
              {transactionUpdateType == 'selected' ? n : count} transaction
              statuses
            </Text>{' '}
            to <Text strong>{newStatus}</Text>.
          </Text>
          <Text>Do you want to proceed?</Text>
        </div>
      </Modal>
    </>
  );
}
